/**
 * @file The action component allows users to duplicate a shift or shift template to the same or the other
 * @author Maarten Lensink
 */
import * as tslib_1 from "tslib";
import { FormControl } from '@angular/forms';
import { OverlayProvider } from '../../ui/overlay-provider';
import { OverlayService } from '../../core/overlay.service';
import { AlertsService } from '../../core/alerts.service';
import { DomainService } from '../../domain.service';
import { EntityQuery } from 'breeze-client';
import { TranslateService } from '@ngx-translate/core';
import { AbstractBase } from '../../core/helpers/abstract-base';
var CopyShiftComponent = /** @class */ (function (_super) {
    tslib_1.__extends(CopyShiftComponent, _super);
    /**
     * Creates an instance of CopyShiftComponent.
     * @param {OverlayProvider} overlayProvider Contains the source shift (template)
     * @param {OverlayService} overlayService Can close the overlay
     * @param {AlertsService} alertsService Can show alerts
     * @param {DomainService} domainService Can save changes
     */
    function CopyShiftComponent(overlayProvider, overlayService, alertsService, domainService, translateService) {
        var _this = _super.call(this) || this;
        _this.overlayService = overlayService;
        _this.alertsService = alertsService;
        _this.domainService = domainService;
        _this.translateService = translateService;
        /**
         * The controls are necessary for the form to work
         */
        _this.templateControl = new FormControl();
        _this.dateControl = new FormControl();
        _this.resourcesControl = new FormControl();
        _this.nameControl = new FormControl();
        /**
         * The formates form the choices for the radio inputs
         */
        _this.templateFormat = [
            { value: false, labelKey: 'APP.MISC.SHIFT.#NEW' },
            { value: true, labelKey: 'APP.MISC.SHIFTTEMPLATE.#NEW' }
        ];
        _this.resourcesFormat = [
            { value: true, labelKey: 'APP.TEMPLATES.ALL' },
            { value: false, labelKey: 'APP.TEMPLATES.NONE' }
        ];
        /** Indicates whether the shift (template) is copied into a(nother) shift template */
        _this.copyToTemplate = false;
        /** Indicates whether the attendants' resources are copied */
        _this.copyResources = false;
        _this.provider = overlayProvider;
        return _this;
    }
    /**
     * Sets the resource to be displayed
     */
    CopyShiftComponent.prototype.ngOnInit = function () {
        var _this = this;
        var providerEntity = this.provider.entity;
        var dataSource = this.provider.configuration.data.dataSource;
        if (!providerEntity) {
            this.alertsService.createAlert('warning', 'APP.TEMPLATES.SHIFT_NOT_FOUND');
            return;
        }
        this.entity = providerEntity;
        if (!this.entity) {
            this.alertsService.createAlert('warning', 'APP.TEMPLATES.SHIFT_EXPECTED');
        }
        this.copyName = this.entity['Name'];
        this.newStart = this.entity['Start'];
        var query = new EntityQuery(dataSource);
        query.parameters = { oid: this.entity['Oid'] };
        this.domainService.entityManager.executeQuery(query).then(function (response) {
            var result = response.results[0];
            _this.resourcesFormat[0].labelKey = result['Resources'] + ' ' +
                _this.translateService.instant('APP.TEMPLATES.' + (result['Resources'] === '1' ? 'ENTITY' : 'ENTITIES'));
        });
    };
    /**
     * Duplicates the shift (template) into a(nother) shift (template)
     * @param {any} event The button that is pressed
     */
    CopyShiftComponent.prototype.duplicate = function (event) {
        var _this = this;
        if (event) {
            event.target.classList.add('sym-working');
        }
        var include = 'MANAGERS CUSTOMERS DEPARTMENTS DEPLOYMENTS ';
        if (this.copyResources) {
            include += 'RESOURCES ASSIGNMENTS ';
        }
        this.entity.copy(this.newStart, include.trim(), this.copyToTemplate, true);
        this.domainService.saveChanges(function (error) {
            if (error) {
                _this.alertsService.createAlert('warning', 'APP.TEMPLATES.COPIED_TO_SHIFT' + (_this.copyToTemplate ? 'TEMPLATE' : '') + '_UNSUCCESSFULLY');
            }
        }).subscribe(function (result) {
            var copyResult = result.entities.find(function (it) { return it['Origin'] === _this.entity['Oid']; });
            if (copyResult && copyResult['Value'] && copyResult['Value'].length === 1) {
                var entityCopy_1 = copyResult['Value'][0];
                entityCopy_1['Name'] = _this.copyName;
                _this.domainService.saveChanges(function (error) {
                    if (error) {
                        _this.alertsService.createAlert('warning', 'APP.TEMPLATES.COPIED_TO_SHIFT' + (_this.copyToTemplate ? 'TEMPLATE' : '') + '_UNSUCCESSFULLY');
                    }
                    else {
                        _this.alertsService.createAlert('success', 'APP.TEMPLATES.COPIED_TO_SHIFT' + (_this.copyToTemplate ? 'TEMPLATE' : '') + '_SUCCESSFULLY');
                    }
                    if ((entityCopy_1.entityType.shortName === 'ShiftTemplate') === _this.copyToTemplate) {
                        _this.overlayService.closeOverlay('refreshList');
                    }
                    else {
                        _this.overlayService.closeOverlay();
                    }
                });
            }
            else {
                _this.alertsService.createAlert('warning', 'APP.TEMPLATES.COPIED_TO_SHIFT' + (_this.copyToTemplate ? 'TEMPLATE' : '') + '_UNSUCCESSFULLY');
                _this.overlayService.closeOverlay();
            }
        });
    };
    /**
     * Closes the overlay without saving
     */
    CopyShiftComponent.prototype.cancel = function () {
        this.overlayService.closeOverlay();
    };
    return CopyShiftComponent;
}(AbstractBase));
export { CopyShiftComponent };
